<template>
  <div>
    <div v-if="item" v-disable-all="isReadonly">
      <div class="row my-3">
        <div class="col col-md-12">
          <div class="form-group required">
            <label class='control-label'>Дата</label>
            <date-component :disabled="isReadonly" v-model="item.dateMeeting" :required="true"/>
          </div>
        </div>
        <div class="col col-md-12">
          <div class="form-group required">
            <component-input
                label="Контактное лицо (ФИО, должность)"
                v-model="item.contactPerson"
                :required="true"
                placeholder="Введите ФИО и должность"
            />
          </div>
        </div>
        <div class="col col-md-12">
          <div class="form-group required">
            <component-input
                label="Контакты (tel, e-mail)"
                v-model="item.contactInfo"
                :required="true"
                placeholder="Введите контактные данные"
            />
          </div>
        </div>
        <div class="col  col-md-12">
          <div class="form-group required">
            <label class='control-label'>Итог общения</label>
            <div><textarea class="form-control" v-model="item.result"/></div>
            <div class="invalid-msg" v-if="v$.item.result.$error">Поле обязательно для заполнения</div>
          </div>
        </div>
        <div class="form-group col col-md-12 required">
          <label class="control-label">Статус работодателя</label>
          <div>
            <Select2 v-model="item.employerStatusId" :options="employerStatuses" :settings="select2Settings"/>
            <div class="invalid-msg" v-if="v$.item.employerStatusId.$error">Поле обязательно для заполнения</div>
          </div>
        </div>
      </div>
    </div>
    <div class="float-right d-flex align-items-center">
      <button-component class="btn btn-primary mx-2" v-if="!isReadonly" :disabled="isPost"
                        v-on:click="save">Сохранить
      </button-component>
      <button-component type="button" kind="secondary" class="btn btn-default" v-on:click="close">Закрыть
      </button-component>
    </div>
  </div>
</template>
<script>
import API from '../api/vacancyHistory';
import Utils from "@/common/utils";
import Constants from '@/common/constants'
import {required} from '@vuelidate/validators'
import {useVuelidate} from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent"
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import disableAll from "@/common/directives/disable-all";

const selectValidator = (value) => value > 0;

export default {
  name: "VacancyHistoryCard",
  components: {
    ButtonComponent,
    DateComponent,
    ComponentInput
  },
  directives: {
    'disable-all': disableAll
  },
  props: {
    vacancyId: Number,
    cardId: {
      type: Number,
      required: false,
      default: null
    },
    isReadonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    this.loadLists();
    this.loadPage();
  },
  data() {
    return {
      item: {
        dateMeeting: null,
        vacancyId: 0
      },
      employerStatuses: [
        {id: 0, text: Constants.emptySelectOptionText, selected: true},
      ],
      isPost: false
    };
  },
  methods: {
    loadLists() {
      Utils.loadSelectOptions("employerStatus", this.employerStatuses);
    },
    loadPage() {
      if (this.cardId) {
        API.find(this.cardId).then((response) => {
          this.item = response.data;
        });
      } else {
        this.item.vacancyId = this.vacancyId;
      }
    },
    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }
      this.isPost = true;
      API.save(this.item)
          .then((response) => {
            Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
            if (response.data.success) {
              this.$emit('save');
            }
            this.isPost = false;
          })
          .catch(() => {
            this.isPost = false;
          });
    },
    close() {
      this.$emit('close');
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        employerStatusId: {required, selectValidator},
        result: {required}
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.form-group.required .control-label:after {
  content: "*";
  color: red;
}
</style>